// extracted by mini-css-extract-plugin
module.exports = {"title":"_1kP7-Y","shine-lines":"_2lcB8P"};